import React, { useContext, useState } from 'react';

import { Link } from 'react-router-dom';
import Table from '../../../../Utils/Grid';
import { useList } from '../../../../../hooks/useList';
import LoaderContext from '../../../../../context/LoaderContext';
import { standardActions } from '../../../../Utils/Grid/StandardActions';
import { dateFormatter } from '../../../../../../utility/formatFields';
import TitleUnderline from '../../../../Utils/TitleUnderline';
import FilterInputs from '../../Utils/FilterInputs';
import UserContext from '../../../../../context/UserContext';
import {
    SCHOOL_COORDINATOR,
    INVITED,
    ASSISTANT,
    TRAINER,
    SCHOOL_TRAINER,
} from '../../../../../../utility/constants'

const ListProducts = () => {
    const [filters, setFilter] = useState({
        search: '',
        start: '',
        end: '',
    });
    const { loader } = useContext(LoaderContext);
    const { user }= useContext(UserContext);
    const { data, getData, page } = useList('transfer', {
        ordering: '-id',
        search: filters.search,
        start: filters.start,
        end: filters.end,
        type_transfer: 'convert',
    });

    const format = (cell) => {
        try {
            return cell.name ? cell.name : cell;
        } catch (error) {
            return '---';
        }
    };
    return (
        <React.Fragment>
            <FilterInputs
                module_title="Conversión de kits"
                search_placeholder="Buscar por ubicación entrada o salida"
                getData={getData}
                filters={filters}
                setFilter={setFilter}
            />
            <div className="d-flex flex-column flex-md-row justify-content-between mt-5">
                <TitleUnderline title="Listado de Conversiónes" />
                { user.type !== TRAINER &&(
                <Link
                    to="/inventory/kit_conversion/create"
                    className="btn btn-primary"
                >
                    Convertir Kit
                </Link>
                )}
            </div>
            <Table
                data={data}
                onPageChange={(page) => getData(page)}
                page={page}
                loading={loader}
            >
                <TableHeaderColumn
                    dataField="id"
                    dataAlign="center"
                    width="10rem"
                    isKey
                    dataFormat={standardActions({
                        view: '/inventory/kit_conversion',
                        // update: '/inventory/transfer',
                    })}
                >
                    Herramientas
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="date"
                    dataSort={true}
                    dataFormat={dateFormatter}
                >
                    Fecha
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="origin"
                    dataFormat={format}
                >
                    Ubicación sale
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="destination"
                    dataFormat={format}
                >
                    Ubicación entra
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="user_movement"
                    dataFormat={format}
                    tdStyle={(_, data) => {
                        const { is_annulled, reason_annulment } = data;
                        return is_annulled
                            ? {
                                  textDecoration: 'line-through',
                                  opacity: 0.6,
                              }
                            : {};
                    }}
                >
                    Realizado por
                </TableHeaderColumn>
            </Table>
        </React.Fragment>
    );
};

export default ListProducts;
